import { BrandfolderHexColors } from '@brandfolder/react';
import classNames from 'classnames';
import { FunctionComponent, HTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';

interface PagesEditProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  only?: boolean;
  page?: boolean;
  section?: boolean;
}

const UnstyledPagesEdit: FunctionComponent<PagesEditProps> = (props) => {
  const { children, only, page, section, ...otherProps } = props;

  return (
    <div
      {...otherProps}
      className={classNames({
        'page-edit': true,
        'page-edit--only': only,
        'page-edit--page': page,
        'page-edit--section': section,
        [`${otherProps?.className}`]: !!otherProps?.className
      })}
    >
      {children}
    </div>
  );
};

const StyledPagesEdit = styled(UnstyledPagesEdit)`
  align-items: center;
  background-color: ${BrandfolderHexColors.DirtyMarshmallowHalf};
  display: flex;
  min-height: 48px;
  padding: 6px 8px;

  &.page-edit--page {
    &.page-edit--only {
      margin-left: 32px;
    }
  }

  &.page-edit--section {
    margin-left: 12px;

    &.page-edit--only {
      margin-left: 44px;
    }
  }

  &:hover {
    background-color: ${BrandfolderHexColors.DirtyMarshmallow};
  }
`;

export const PagesEdit: FunctionComponent<PagesEditProps> = (props) => {
  return <StyledPagesEdit {...props} />;
};
